export const locales = ['en', 'zh-TW'] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

/** Default locale; used by the en-bound `translate()` in `src/core/translations`. */
export const locale: Locale = defaultLocale;

export const isLocale = (value: unknown): value is Locale =>
  typeof value === 'string' && (locales as readonly string[]).includes(value);

export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';

export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
